import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

import store from '../store';
import {getValueOfFeature, pimText, pimTextDebug} from '../util/values';
import {selectProductDatas, selectSpcAttributes, selectSpcConfiguration, selectSpcConfigurations, selectSpcSessions} from '../selectors';

@customElement('trans-label')
export class TransLabel extends connect(store)(LitElement) {

	@property({type: String})
	prefix = '';

	@property({type: String})
	suffix = '';

	@property({type: String})
	key = '';

	@property({type: String})
	value = null;

	@property({type: String})
	context = 'F';

	@property({type: String})
	default = '';

	@property({type: String})
	instanceId = 'default';

	@property({type: Boolean})
	showIdWhenMissing = false;

	constructor() {
		super();
		this.translations = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
		this.session = selectSpcSessions(state)[this.instanceId];
		this.deploymentName = this.session?.getSessionContext().configurationModelSource.deploymentName.replace('ComponentsV2-', '');
		const productDatas = selectProductDatas(state);
		//console.log('transLabel stateChanged', this.deploymentName, productDatas);
		if (Object.hasOwn(productDatas, this.deploymentName)) {
			this.translations = productDatas[this.deploymentName].translations;
		}
		const spcConfigurations = selectSpcConfigurations(state);
		if (spcConfigurations && Object.hasOwn(spcConfigurations, this.instanceId)) {
			this.spcConfiguration = spcConfigurations[this.instanceId];
		}
		this.debug = state.status.debug;
	}
	/*
		available Contexts
		SC: 'SystemComponent',
		F: 'Feature',
		'F.S': 'Feature.ShortText',
		'F.L': 'Feature.LongText',
		'F.D': 'Feature.DescriptionUx',
		FV: 'FeatureValue',
		'FV.S': 'FeatureValue.ShortText',
		'FV.L': 'FeatureValue.LongText',
		'FV.D': 'FeatureValue.DescriptionUx',
		D: 'Description',
		'D.S': 'Description.ShortText',
		'D.L': 'Description.LongText',
		'D.D': 'Description.DescriptionUx',
		DV: 'DescriptionValue',
		'DV.S': 'DescriptionValue.ShortText',
		'DV.L': 'DescriptionValue.LongText',
		'DV.D': 'DescriptionValue.DescriptionUx',
	*/
	render() {
		return this.debug?
			html`<span title="${this.key + ' ' + this.context}">${pimTextDebug(this.lang, this.key, this.context, this.spcConfiguration, this.translations, this.value, this.prefix, this.suffix, this.default)}</span>`:
			html`<span title="${this.key + ' ' + this.context}">${pimText(this.lang, this.key, this.context, this.spcConfiguration, this.translations, this.value, this.prefix, this.suffix, this.default, this.showIdWhenMissing)}</span>`;
	}
}
